import React from 'react';
import '../../styles.css';
import AttemptBox from '../AttemptBox.js';


function TenAttemptsRow(props) {
    var values = props.values
    let attempts = [];
    let userLastEightLetters = [];
    let userAttemptOutcomes = [];
    for (var i = 0; i < values.length; i++) {
        if (i % 2 === 0) {
            userLastEightLetters.push(values[i].toUpperCase())
        }
        else {
            userAttemptOutcomes.push(values[i])
        }
    }

    for (let i = 0; i < values.length; i++) {
        attempts[i] = <AttemptBox bool={userAttemptOutcomes[i]} letter={userLastEightLetters[i]} />;
    }


    return (
        <div className='tenAttemptRow'>
            {attempts}
        </div>
    );
}

export default TenAttemptsRow;